import { render, staticRenderFns } from "./TaxNo.vue?vue&type=template&id=1b4cfd42&"
import script from "./TaxNo.vue?vue&type=script&lang=js&"
export * from "./TaxNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports